/**
 * Download CSV text as a file (web build — no Capacitor).
 *
 * @param {string} filename e.g. "report_2026-08-01.csv"
 * @param {string} content  the full CSV text
 */
export default function exportCsv(filename, content) {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
